exports = module.exports = require("../../../../../math-wordproblems/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td,th{vertical-align:middle}", ""]);

// exports
